import { createContext, useContext, useState } from 'react';

const EbayAccountContext = createContext(null);

export const EbayAccountProvider = ({ children }) => {
  const [expiredAccounts, setExpiredAccounts] = useState([]);
  return (
    <EbayAccountContext.Provider value={{ expiredAccounts, setExpiredAccounts }}>
      {children}
    </EbayAccountContext.Provider>
  );
};

export const useEbayAccount = () => useContext(EbayAccountContext);
